export default "__VITE_ASSET__CCg$qGAI__"